import React, {Component} from 'react';
import {DefaultIconButton} from '../button/DefaultIconButton';

class ColorModeSwitch extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    let icon = global.theme === 'dark' ? 'sun' : 'moon';
    return (
      <DefaultIconButton
        iconName={icon}
        mode="text"
        iconType="FA5"
        action={global.ToggleColorMode}
      />
    );
  }
}

export default ColorModeSwitch;
